import { createStore } from 'vuex';
import Cookies from 'js-cookie';

export default createStore({
  state: {
    isAuthenticated: false,
    cart: [],
    userName: '',
  },
  mutations: {
    setAuthenticated(state, status) {
      state.isAuthenticated = status;
    },
    setUserName(state, name) {
      state.userName = name;
    },
    addToCart(state, product) {
      const existingProduct = state.cart.find(item => item.product_id === product.product_id);
      if (existingProduct) {
        existingProduct.quantity += 1;
      } else {
        state.cart.push({ ...product, quantity: 1 });
      }
    },
    removeFromCart(state, productId) {
      state.cart = state.cart.filter(item => item.product_id !== productId);
    },
    clearCart(state) {
      state.cart = [];
    },
    increaseQuantity(state, productId) {
      const item = state.cart.find(item => item.product_id === productId);
      if (item) {
        item.quantity++;
      }
    },
    decreaseQuantity(state, productId) {
      const item = state.cart.find(item => item.product_id === productId);
      if (item) {
        if (item.quantity > 1) {
          item.quantity--;
        } else {
          state.cart = state.cart.filter(item => item.product_id !== productId);
        }
      }
    },
  },
  actions: {
    login({ commit }, userName) {
      commit('setAuthenticated', true);
      commit('setUserName', userName);
      Cookies.set('auth', 'true');
    },
    logout({ commit }) {
      commit('setAuthenticated', false);
      commit('setUserName', '');
      Cookies.remove('auth');
      commit('clearCart');
    },
    checkAuth({ commit }) {
      const auth = Cookies.get('auth');
      commit('setAuthenticated', !!auth);
    },
  },
  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
    cartItems: (state) => state.cart,
    cartTotal: (state) => {
      return state.cart.reduce((total, item) => total + item.price * item.quantity, 0);
    },
    userName: (state) => state.userName,
  },
});